export const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false
})
